"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var icon_1 = __importDefault(require("../../icon"));
function ClassifyTabsMobile(props) {
    var _a = props || {}, onChange = _a.onChange, _b = _a.list, configuration = _b === void 0 ? [] : _b;
    var _c = (0, react_1.useState)(false), expendNode = _c[0], setExpendNode = _c[1];
    var _d = (0, react_1.useState)(configuration.length ? configuration[0] : {}), currentTxt = _d[0], setCurrentTxt = _d[1];
    var selectRef = (0, react_1.useRef)(null);
    var clickPane = function () {
        setExpendNode(!expendNode);
    };
    var selectChild = function (item) {
        var _a = item || {}, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.id, id = _c === void 0 ? '' : _c;
        if (name) {
            setCurrentTxt(__assign(__assign({}, (currentTxt || {})), { name: name }));
            setExpendNode(!expendNode);
        }
        else {
            setCurrentTxt(__assign({}, (currentTxt || {})));
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    };
    return (react_1.default.createElement("div", { className: 'classify-tabs-m' },
        react_1.default.createElement("div", { onClick: clickPane, className: (0, classnames_1.default)('item box-shadow', {
                'box-shadow-ex': expendNode,
            }) },
            react_1.default.createElement("span", { className: 'title' }, currentTxt ? currentTxt.name || '' : ''),
            react_1.default.createElement("span", { className: (0, classnames_1.default)('icon', {
                    'icon-rotate': expendNode,
                }) },
                react_1.default.createElement(icon_1.default, { name: "arrow-down", size: 24 }))),
        react_1.default.createElement("div", { className: 'max-view' },
            react_1.default.createElement("div", { ref: selectRef, style: { overflow: 'hidden', transition: ' all 0.3s ease' }, className: (0, classnames_1.default)('container', {
                    'is-show': expendNode,
                }) }, configuration.map(function (item, index) {
                var _a = item || {}, _b = _a.name, name = _b === void 0 ? '' : _b, extendProps = _a.extendProps;
                return (react_1.default.createElement("div", __assign({ onClick: function () {
                        selectChild(item);
                    } }, (extendProps || {}), { key: index, style: currentTxt && currentTxt.name === name
                        ? {
                            background: '#EFF6FF',
                        }
                        : {}, className: 'item item-hover' }),
                    react_1.default.createElement("span", { className: 'title title-extend' }, name)));
            })))));
}
exports.default = ClassifyTabsMobile;
//# sourceMappingURL=ClassifyTabsMobile.js.map